// Central place for nav + footer config and the persistent risk line.
export const NAV_LINKS = [
    { label: "How it works", to: "/how-it-works" },
    { label: "Markets", to: "/markets" },
    { label: "Methodology", to: "/methodology" },
    { label: "Pricing", to: "/pricing" },
];

export const FOOTER_GROUPS = [
    {
        title: "Product",
        links: [
            { label: "How it works", to: "/how-it-works" },
            { label: "Platform", to: "/platform" },
            { label: "Markets", to: "/markets" },
            { label: "Pricing", to: "/pricing" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About", to: "/about" },
            { label: "Methodology", to: "/methodology" },
            { label: "Resources", to: "/resources" },
            { label: "FAQ", to: "/faq" },
        ],
    },
    {
        title: "Legal",
        links: [
            { label: "Risk disclosure", to: "/legal/risk-disclosure" },
        ],
    },
];

export const PERSISTENT_RISK_LINE =
    "Trading stocks and futures involves substantial risk of loss and is not suitable for everyone. Past or simulated performance does not guarantee future results. The Aegis Line is a software tool, not financial advice.";

export const TRUST_STRIP = "Stocks · Futures · Every decision logged · The line holds";
